module.exports = __webpack_public_path__ + "static/media/gas-station.e9772354.svg";